import React from 'react';
import Checkbox from '@mui/material/Checkbox';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import {CheckBox, CheckBoxOutlineBlank} from '@mui/icons-material';
import {theme} from '../../Theme';

interface IProps {
  checked?: boolean;
  defaultChecked?: boolean;
  value?: boolean;
  label?: any;
  name?: string;
  onChange?: any;
  secondary?: boolean;
  size?: string;
  style?: any;
  classes?: any;
  color?: string;
  disabled?: boolean;
}

export default function BidmiiCheckbox(props: IProps) {
  return (
    <Grid
      container={Boolean(props.label)}
      alignItems="center"
      direction={
        props.label ? (props.secondary ? 'row-reverse' : 'row') : undefined
      }
      justifyContent={props.secondary ? 'space-between' : 'flex-start'}
      wrap={props.label ? 'nowrap' : undefined}
      style={{marginLeft: -11}}>
      <Checkbox
        checked={props.checked}
        defaultChecked={props.defaultChecked}
        value={props.value}
        disabled={props.disabled}
        icon={
          <CheckBoxOutlineBlank
            style={{
              color: !props.disabled
                ? theme.palette.gray.medium
                : theme.palette.gray.border,
            }}
          />
        }
        checkedIcon={
          <CheckBox style={{color: props.color || theme.palette.blue.main}} />
        }
        name={props.name}
        onChange={props.onChange}
        style={{...props.style}}
      />
      <Typography
        variant="subtitle2"
        component="span"
        color={
          !props.disabled
            ? theme.palette.text.primary
            : theme.palette.text.secondary
        }
        style={{fontSize: props.size === 'small' ? 12 : 14, lineHeight: 1.3}}>
        {props.label}
      </Typography>
    </Grid>
  );
}
